import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getWarehousesForTeam = unaryRpc({
  name: "getWarehousesForTeam" as const,
  input: z.object({}),
  output: z.object({
    warehouses: z.array(z.object({ id: z.string(), name: z.string() })),
  }),
});
